/**
 * Formatting utility functions
 */

import { fromYMD } from './date';

export function formatShortMDY(ymd: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  return `${m}/${String(d).padStart(2, '0')}/${String(y).slice(-2)}`;
}

export function formatWeekday(ymd: string, style: 'short' | 'long' = 'short'): string {
  return fromYMD(ymd).toLocaleDateString(undefined, { weekday: style });
}

export function formatWeekRange(start: string, end: string): string {
  const fmt = (ymd: string) => {
    const d = fromYMD(ymd);
    return d.toLocaleString('default', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };
  return `${fmt(start)} – ${fmt(end)}`;
}

export function getPositionAcronym(position: string): { abbr: string; label: string } | null {
  const normalized = position.toLowerCase().trim();
  if (!normalized) return null;

  if (normalized.includes('dentist') || normalized === 'dds') {
    return { abbr: 'DDS', label: 'Dentist' };
  }
  if (normalized.includes('hygienist') || normalized === 'rdh') {
    return { abbr: 'RDH', label: 'Dental Hygienist' };
  }
  if (normalized.includes('assistant') || normalized === 'da') {
    return { abbr: 'DA', label: 'Dental Assistant' };
  }
  if (normalized.includes('office') || normalized.includes('front')) {
    return { abbr: 'OFF', label: 'Office Staff' };
  }
  return null;
}

export function formatProfessionalName(professional: {
  first_name?: string;
  last_initial?: string;
}): string {
  const first = (professional.first_name || '').trim();
  const last = (professional.last_initial || '').trim();
  return `${first}${first ? ' ' : ''}${last ? last + '.' : ''}`;
}
